import React from 'react'
import styles from "../myprofile/myprofile.module.css"
import ProfileMenu from '../../Components/profilemenu/ProfileMenu'
import ReceivedEnquiresTab from '../../Components/allEnquiresTab/ReceivedEnquiresTab'
import Myprofile from '../myprofile/Myprofile'

const ReceivedEnquires = () => {
    return (
        <>
            <Myprofile className={styles.myprofile}>
             
                <ReceivedEnquiresTab />
            </Myprofile>
        </>
    )
}

export default ReceivedEnquires